export const main_server = "https://api.themoviedb.org/3/";
export const api_key = "75b562f32ea30cc08f04433c5d722d4c";

export const user = [
  {
    email: "nahid@gmail.com",
    password: "123456"
  },
  {
    email: "test@email.com",
    password: "123456"
  }
];
